import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingDealsLp1002Payment',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/deals-lp-1002/',
    component: () => import('@/modules/deals-lp-1002/layout/LayoutPage.vue'),
    children: [
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/deals-lp-1002/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
